export const EmptyStr = '';
export const ATIVO = 1;
export const INATIVO = 2;
